import { render, staticRenderFns } from "./DialogEditor.vue?vue&type=template&id=f7bf9470&scoped=true"
import script from "./DialogEditor.vue?vue&type=script&lang=js"
export * from "./DialogEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7bf9470",
  null
  
)

export default component.exports